var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"896ade870e1d8ea4f18e0345a82d2c8e75f4d095"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["bridge128@bridge128-96"]={id:"896ade870e1d8ea4f18e0345a82d2c8e75f4d095"};
      